import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { Paper, IconButton, Tooltip, Typography } from '@mui/material';
import {
  CenteredFlexBox,
  FullSizeCenteredFlexBox,
} from '../../../../Components/FlexBox';
import StyledSwitch from '../../../../Components/Inputs/StyledSwitch';
import Chip from '../../../../Components/Chip';
import capitalize from '../../../../Helpers/StringsFormatting/capitalize';
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import DetailsDialog from './DetailsDialog';

const ActivityOutcomeItem = function ActivityOutcomeItem({
  id,
  name,
  campaignAdvancement,
  extensionData,
  isActive,
  onChangeIsActive,
  onEdit,
  icon,
  activityTypeName,
  activityTypes,
}) {
  const intl = useIntl();
  const [open, setOpen] = useState(false);

  const handleChange = (event) => {
    event.stopPropagation();
    onChangeIsActive(id, event.target.checked);
  };

  const handleSwitchClick = (event) => {
    event.stopPropagation();
  };

  const handleEdit = (event) => {
    event.stopPropagation();
    onEdit(id);
  };

  const handleOpenDetails = () => {
    setOpen(true);
  };
  const handleCloseDetails = () => {
    setOpen(false);
  };

  return (
    <>
      <DetailsDialog
        open={open}
        onClose={handleCloseDetails}
        activityTypeName={activityTypeName}
        activityTypes={activityTypes}
        data={{ id, name, campaignAdvancement, isActive, extensionData }}
      />
      <Paper
        id={`${id}-activity-outcome-item`}
        variant="outlined"
        onClick={handleOpenDetails}
        sx={{
          width: '50%',
          '&:hover': {
            cursor: 'pointer',
            backgroundColor: 'rgba(88, 147, 212, 0.16)',
          },
        }}
      >
        <FullSizeCenteredFlexBox gap="24px" padding="16px">
          <CenteredFlexBox gap="16px" sx={{ flexGrow: 0, width: '35%' }}>
            {icon}
            <Typography variant="h6">
              {capitalize(intl.messages[name?.toUpperCase()] ?? name)}
            </Typography>
          </CenteredFlexBox>
          <Chip
            id={`${name}-call-percentage`}
            variant="outlined"
            label={`${campaignAdvancement}%`}
            fontSize="1.5rem"
            width="100px"
            color="#1D5B9D"
          />
          <CenteredFlexBox flexGrow={0} marginLeft="auto" gap="8px">
            <Tooltip title={intl.messages.EDIT} placement="bottom">
              <IconButton
                id={`edit-${id}-causal-button`}
                size="large"
                onClick={handleEdit}
              >
                <EditRoundedIcon />
              </IconButton>
            </Tooltip>
            <StyledSwitch
              id={`isActive-switch-${id}`}
              size="small"
              checked={isActive}
              onChange={handleChange}
              onClick={handleSwitchClick}
              sx={{ marginLeft: '11px' }}
            />
          </CenteredFlexBox>
        </FullSizeCenteredFlexBox>
      </Paper>
    </>
  );
};

export default ActivityOutcomeItem;
